import { FC } from 'react';
import { PageTitle, PageLink } from '../../../rbts/layout/core';
import { View } from './components/View';

const ActivityLogPage: FC = () => {
  

  return (
    <>
      <PageTitle>{`${'Registro de actividad'}`}</PageTitle>
      <View />
    </>
  );
};

export { ActivityLogPage };
